import MagnifyingGlassPng from '../../../../../../app/assets/images/shared/icons/illo-magnifying-glass-lg@2x.png';

const APP_PROPERTIES = {
  BETA: 'beta',
  COMING_SOON: 'coming_soon',
  PREFERRED_PARTNER: 'preferred_partner',
};

export const MagnifyingGlass = {
  src: MagnifyingGlassPng,
  alt: 'Illustration of Magnifying Glass',
};

// eslint-disable-next-line import/prefer-default-export
export { APP_PROPERTIES };
